import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { computed } from 'vue'
import type { ConversationBotInfo } from '@/services/wootdashConversations'


export default /*@__PURE__*/_defineComponent({
  __name: 'BotVersionTag',
  props: {
    bot: {},
    variant: { default: 'light' }
  },
  setup(__props: any) {

const props = __props

const STATUS: Record<string, string> = {
  running: 'o bot está atendendo',
  handoff: 'passou para atendente',
  ended: 'o bot encerrou',
  expired: 'encerrada por tempo sem resposta',
}

const live = computed(() => props.bot.status === 'running')
const outdated = computed(() => props.bot.latestVersionNumber != null && props.bot.latestVersionNumber !== props.bot.versionNumber)
const what = computed(() => (props.bot.kind === 'rating' ? 'Avaliação' : 'Bot'))

const label = computed(() => {
  const version = `v${props.bot.versionNumber}`
  const base = live.value ? `${what.value} ${props.bot.botName} · ${version}` : props.bot.kind === 'rating' ? `Avaliação · ${version}` : `Passou pelo bot · ${version}`
  return outdated.value ? `${base} (atual v${props.bot.latestVersionNumber})` : base
})

const fmt = (iso: string) => new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })

const tooltip = computed(() => {
  const b = props.bot
  const lines = [
    `${what.value}: ${b.botName}`,
    `Versão do fluxo: v${b.versionNumber} (publicada em ${fmt(b.versionPublishedAt)})`,
    `Começou em ${fmt(b.startedAt)} — ${STATUS[b.status] ?? b.status}`,
  ]
  if (b.waitingOn) lines.push(`Parado em: ${b.waitingOn}`)
  if (outdated.value) lines.push(live.value ? `Publicada a v${b.latestVersionNumber}: a conversa passa pra ela na próxima mensagem do contato.` : `Terminou na v${b.versionNumber}; a publicada agora é a v${b.latestVersionNumber}.`)
  return lines.join('\n')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['bvt', `bvt--${__props.variant}`, { 'is-live': live.value, 'is-old': outdated.value }]),
    title: tooltip.value
  }, [
    _cache[0] || (_cache[0] = _createStaticVNode("<svg width=\"10\" height=\"10\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" data-v-370884b1><rect x=\"4\" y=\"8\" width=\"16\" height=\"12\" rx=\"3\" data-v-370884b1></rect><path d=\"M12 8V4\" data-v-370884b1></path><circle cx=\"9\" cy=\"14\" r=\"1\" data-v-370884b1></circle><circle cx=\"15\" cy=\"14\" r=\"1\" data-v-370884b1></circle></svg>", 1)),
    _createTextVNode(" " + _toDisplayString(label.value), 1)
  ], 10, _hoisted_1))
}
}

})